import { DotBadgeProps } from "./types"
import React from "react"
import styled from '~/ui/styled'

const BadgeContainer = styled.View<DotBadgeProps>`
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.danger};
  right: ${({ right }) => right};
  top: ${({ top }) => top};
  padding: 5px;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 10px;
  height: 10px;
  border-width: 1px;
  border-color: white;
  z-index: 1;
`

const DotBadge: React.FC<DotBadgeProps> = ({ top = 0, right = 0, backgroundColor }) => {
  return <BadgeContainer top={top} right={right} backgroundColor={backgroundColor}></BadgeContainer>
}

export default DotBadge
